/**
 * @generated SignedSource<<31df224322857c4f3464ddb86896b2b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CodeSubmissionDialog_Project$data = {
  readonly id: string;
  readonly submission: {
    readonly description: string | null | undefined;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useCodeTestBrowserForm_Project">;
  readonly " $fragmentType": "CodeSubmissionDialog_Project";
};
export type CodeSubmissionDialog_Project$key = {
  readonly " $data"?: CodeSubmissionDialog_Project$data;
  readonly " $fragmentSpreads": FragmentRefs<"CodeSubmissionDialog_Project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CodeSubmissionDialog_Project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectSubmission",
      "kind": "LinkedField",
      "name": "submission",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCodeTestBrowserForm_Project"
    }
  ],
  "type": "Project",
  "abstractKey": null
};

(node as any).hash = "fcbd68c81908c0c0bd6ccc6e6c7e2f5c";

export default node;
